






















































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { User } from "@/models/User";
import { saveAs } from "file-saver";
import { ExportToCsv, Options } from "ts-export-to-csv";
import session from "@/services/SessionService";
import messageService from "@/services/MessageService";
import documentService, { DocumentSearch } from "@/services/DocumentService";
import { Sample } from "@/models/Sample";
import searchService, { SearchFilter } from "@/services/SearchService";
import DocumentFiltersMenu from "../../components/DocumentFiltersMenu.vue";
import DocumentExportMenu from "../../components/DocumentExportMenu.vue";

type ExportedDocument = {
  document: string;
  number: string;
  work_order: string;
  budget: string;
  project: string;
  client: string;
  work_code: string;
  work_serial_number: string;
  sampled_at: string;
  state: string;
  downloaded: string;
};

@Component({
  filters: {
    truncate: function (value: string, limit?: number) {
      if (value && value.length > (limit || 50))
        return value.substring(0, limit || 50) + "...";
      return value;
    },
  },
  components: {
    DocumentFiltersMenu,
    DocumentExportMenu,
  },
})
export default class DocumentIndex extends Vue {
  // Static variables
  static GENERATE_URL_ERROR = 1;
  static GENERATE_URL_SUCCESS = 2;
  static CLIPBOARD_SUCCESS = 3;

  loading: boolean = false;
  urlLoading: number = 0;
  sessionUser: User | null;
  headers = [
    {
      text: "N° Informe",
      value: "NUMINF",
      align: "left",
      class: "dense",
    },
    {
      text: "N° Muestra",
      value: "NUMMUE",
      align: "left",
      class: "dense",
    },
    {
      text: "Órd. Trabajo",
      value: "work_order.number",
      sortable: false,
      align: "left",
      class: "dense",
    },
    {
      text: "Presupuesto",
      value: "work_order.budget.number",
      align: "left",
      sortable: false,
      class: "dense",
    },
    {
      text: "Proyecto",
      value: "IDPROJ",
      align: "left",
      sortable: false,
      class: "dense",
    },
    {
      text: "Cliente",
      value: "IDCLI",
      align: "left",
      sortable: false,
      class: "dense",
    },
    {
      text: "Cód. Obra",
      value: "project.work_code",
      align: "left",
      sortable: false,
      class: "dense",
    },
    {
      text: "Corr. Obra",
      value: "COROBR",
      align: "left",
      sortable: true,
      class: "dense",
    },
    {
      text: "Fecha Muestra",
      value: "FECMUE",
      align: "left",
      class: "dense",
    },
    {
      text: "Fecha Subida",
      value: "FECSUBINF",
      align: "left",
      sortable: true,
      class: "dense",
    },
    {
      text: "Estado",
      value: "contact",
      align: "left",
      sortable: false,
      class: "dense",
    },
    {
      text: "Descarga",
      value: "",
      align: "center",
      sortable: false,
      class: "dense",
    },
  ];

  constructor() {
    super();
    this.sessionUser = session.getUser();
    this.search = {
      pagination: searchService.pagination,
      filters: searchService.filters,
    };
    this.search.pagination.sortBy = "FECSUBINF";
    this.search.pagination.descending = true;
  }

  search: DocumentSearch;
  totalDocuments: number = 0;
  documents: Sample[] | Sample | undefined = [];
  exportableDocuments: Sample[] | Sample | undefined = [];

  removeFilter(key: string) {
    let prev = this.search.filters.findIndex((filter) => {
      return filter.key == key;
    });
    if (prev >= 0) {
      this.search.filters.splice(prev, 1);
    }
  }

  loadDocuments() {
    this.loading = true;
    documentService
      .get(this.search)
      .then((response) => {
        this.documents = response.data ? response.data.samples : [];
        this.search.pagination = response.data
          ? response.data.pagination
          : this.search.pagination;
        this.totalDocuments = response.data
          ? (response.data.pagination.totalItems as number)
          : this.totalDocuments;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  async loadExportableDocuments() {
    this.loading = true;
    const exportSearch: DocumentSearch = {
      filters: this.search.filters,
      pagination: {
        ...this.search.pagination,
        ...{
          rowsPerPage: null,
        },
      },
    };
    const response = await documentService.get(exportSearch);
    this.exportableDocuments = response.data ? response.data.samples : [];
    this.loading = false;
  }

  download(sample: Sample) {
    this.urlLoading = sample.id;
    documentService
      .presignedUrl(sample.id)
      .then((response) => {
        messageService.addMessage({
          id: DocumentIndex.GENERATE_URL_SUCCESS,
          type: "info",
          text: "Se ha generado el link de descarga.",
          overrides: true,
        });
        sample.url = response.data.url;
      })
      .catch(() => {
        messageService.addMessage({
          id: DocumentIndex.GENERATE_URL_ERROR,
          type: "error",
          text: "Ocurrió un error al generar la URL de descarga. Intente más tarde.",
          overrides: true,
        });
      })
      .finally(() => {
        this.urlLoading = 0;
      });
  }

  copyToClipboard(sample: Sample) {
    messageService.addMessage({
      id: DocumentIndex.CLIPBOARD_SUCCESS,
      type: "info",
      timeout: 3000,
      text: "El link de descarga se ha copiado al portapapeles.",
      overrides: true,
    });
    return sample.url;
  }

  prepareSamplesForExport(rows: Sample[]) {
    return rows.map((entry: Sample) => {
      return {
        document: entry.document,
        number: entry.number,
        work_order: entry.work_order.id
          ? entry.work_order.number.toString()
          : "",
        budget: String(
          entry.work_order.id
            ? typeof entry.work_order.budget == "number"
              ? entry.work_order.budget.toString()
              : entry.work_order.budget.number
            : ""
        ).toUpperCase(),
        project: entry.project.name || "",
        client: entry.client.name || "",
        work_code: entry.project.work_code,
        work_serial_number: (entry.work_serial_number || "").toString(),
        sampled_at: entry.sampled_at,
        uploaded_at: entry.uploaded_at
          ? new Date(entry.uploaded_at).toLocaleString("es-CL")
          : "",
        state:
          entry.state == 1
            ? "Firma Pendiente"
            : entry.state == 2
            ? "Pago Pendiente"
            : "Liberado",
        downloaded: entry.downloaded ? "Si" : "No",
        download_url: entry.download_url,
      };
    });
  }

  generateCSVFromPage() {
    this.loading = true;
    const headers: string[] = this.headers
      .map((header) => header.text)
      .concat(["URL Descarga"]);
    let data: ExportedDocument[] = [];

    if (Array.isArray(this.documents)) {
      data = this.prepareSamplesForExport(this.documents);
    } else if (this.documents) {
      const doc = this.documents as Sample;
      data = this.prepareSamplesForExport([doc]);
    }

    const options: Options = {
      filename: `reporte-${Date.now()}`,
      fieldSeparator: ";",
      showLabels: true,
      columnHeaders: headers,
    };
    const exporter = new ExportToCsv(options);

    exporter.generateCsv(data);
    this.loading = false;
  }

  async generateCSVFromFilter() {
    this.loading = true;
    if (
      Array.isArray(this.exportableDocuments) &&
      this.exportableDocuments.length != this.search.pagination.totalItems
    ) {
      await this.loadExportableDocuments();
    }
    const headers: string[] = this.headers
      .map((header) => header.text)
      .concat(["URL Descarga"]);

    let data: ExportedDocument[] = [];

    if (Array.isArray(this.exportableDocuments)) {
      data = this.prepareSamplesForExport(this.exportableDocuments);
    } else if (this.exportableDocuments) {
      const doc = this.exportableDocuments as Sample;
      data = this.prepareSamplesForExport([doc]);
    }

    const options: Options = {
      filename: `reporte-${Date.now()}`,
      fieldSeparator: ";",
      showLabels: true,
      columnHeaders: headers,
    };
    const exporter = new ExportToCsv(options);

    exporter.generateCsv(data);
    this.loading = false;
  }

  async downloadFile(data: string | Blob, filename: string | undefined) {
    saveAs(data, filename);
  }

  @Watch("search", { deep: true })
  reloadData() {
    if (!this.loading) this.loadDocuments();
  }

  mounted() {
    this.$root.$on("load:documents", () => {
      this.loadDocuments();
    });

    this.$root.$on("filter:apply", (filters: SearchFilter[]) => {
      filters.forEach((filter) => {
        let prev = this.search.filters.findIndex((item) => {
          return item.key == filter.key;
        });
        if (prev >= 0) {
          this.search.filters.splice(prev, 1);
        }

        this.search.filters.push(filter);
      });
    });

    this.$root.$on("export:page:csv", () => {
      this.generateCSVFromPage();
    });

    this.$root.$on("export:filter:csv", () => {
      this.generateCSVFromFilter();
    });

    this.loadDocuments();
  }
}
